import { Component, OnInit } from '@angular/core';
import { DepartmentsService } from '../../../service/component_dependent/users/departments.service';
import { Users } from '../../../model/users';
import { UsersService } from '../../../service/component_dependent/users/users.service';
import { ActivatedRoute, Router } from '@angular/router';
import { RolesService } from '../../../service/component_dependent/users/roles.service';
import { RoleUsersService } from '../../../service/component_dependent/users/role-users.service';
import { RoleUsers } from '../../../model/role-users';
import { NotifierService } from '../../../service/component_dependent/notifier.service';
import { JsonManager } from '../../../service/managers/json-manager';
import { StorageService } from '../../../service/managers/storage.service';
import { count } from 'rxjs/operators';

@Component({
  selector: 'app-users-profile',
  templateUrl: './users-profile.component.html',
  styleUrls: ['./users-profile.component.scss']
})

export class UsersProfileComponent implements OnInit {

  protected departments = [];
  protected roles = [];

  protected mode: string;

  protected roleID: number;

  protected user: Users;

  loadingPID:boolean = false;
  fileName= ""

  dropdownList = [];
  userList = [];
  selectedItems = [];
  selectedUser = [];
  dropdownSettings = {};
  userSettings = {};

  constructor(private departmentsService: DepartmentsService, private usersService: UsersService,
    private route: ActivatedRoute, private rolesService: RolesService, private roleUserService: RoleUsersService,
    private notifierService: NotifierService, private router: Router, private storageService: StorageService) {

    this.initializeComponents();
    this.checkInitRoute(this.route);
  }

  ngOnInit() {
    this.getRoles();

    //this.getStaffList();

    //this.getAssignedStaffList();

    this.dropdownSettings = {
      singleSelection: true,
      idField: 'item_id',
      textField: 'item_text',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: true,
    };

    this.userSettings = {
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_text',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      allowSearchFilter: true,
    };
  }

  public saveAndInsert() {
    this.onSubmit("SAI");
  }

  public saveAndExit() {
    this.onSubmit("SAE");
  }

  protected onSubmit(mode: string) {

    this.user.department_id = this.selectedItems[0].item_id;

    if (this.mode == "create") {
      this.usersService.storeUser(this.user).subscribe(
        (data: any) => {
          let roleUser = this.getRoleUser(data.data.id);

          this.roleUserService.storeRoleUsers(roleUser).subscribe(
            (dataB: any) => {
              if (mode == "SAE") {
                this.exit();
              } else if (mode == "SAI") {
                this.clearRegistrationForm();
              }
              this.notifierService.showSuccess(data.message);
            },
            (error: any) => {
              this.notifierService.showError(JsonManager.getBreakLineSeparatedErrorMessages(error.error.message));
            },
          )
        },
        (error: any) => {
          this.notifierService.showError(JsonManager.getBreakLineSeparatedErrorMessages(error.error.message));
        },
      )
    } else if (this.mode == "update") {

      this.usersService.updateUser(this.user).subscribe(
        (data: any) => {
          let roleUser = this.getRoleUser(this.user.id);
          this.roleUserService.updateRoleUser(roleUser).subscribe(
            (dataB: any) => {
              if (mode == "SAE") {
                this.exit();
              } else if (mode == "SAI") {
                this.clearRegistrationForm();
              }
              this.notifierService.showSuccess(data.message);
            },
            (error: any) => {
              this.roleUserService.storeRoleUsers(roleUser).subscribe(
                (dataB: any) => {
                  if (mode == "SAE") {
                    this.exit();
                  } else if (mode == "SAI") {
                    this.clearRegistrationForm();
                  }
                  this.notifierService.showSuccess(data.message);
                },
                (error: any) => {
                  this.notifierService.showError(JsonManager.getBreakLineSeparatedErrorMessages(error.error.message));
                },
              );
            },
          )
        }, (error: any) => {
          this.notifierService.showError(JsonManager.getBreakLineSeparatedErrorMessages(error.error.message));
        },
      )
    }
  }

  protected getDepartments() {
    this.departmentsService.getDepartments().subscribe(
      (data: any) => {
        this.reassignVariablesDepartments(data);
      }
    )
  }

  protected getRoles() {
    this.rolesService.getRoles(undefined, undefined, undefined).subscribe(
      (data: any) => {
        if (data.data != null) {
          this.roles = data.data;
        }
      }
    )
  }

  public getAssignedStaffList(){
    this.usersService.getAssignedUsers().subscribe(
      (data) => { 
         this.selectedUser = data;
      },
      (err) => {
         alert('Error Getting StaffList:' + JSON.stringify(err))
      }
    )
  }

  public getStaffList(){

    this.usersService.getUserList().subscribe(
      (data) => {
        for (var i = 0; i < data.length; i++) {
          var elem: any;
          elem = data[i];
          const name = elem['first_name'] + ', ' + elem['last_name'];
          this.userList.push({ item_id: elem['id'], item_text: name})
        }
      },
      (err) => {
        alert('Data Error:' + JSON.stringify(err))
      }
    )
   //this.userList.push({ item_id: elem['id'], item_text: elem['department_name']})
  }

  protected onItemSelect(data: any) {
    this.selectedItems = [data];
  }

  private reassignVariablesDepartments(data: any) {

    var init;

    for (var i = 0; i < data.data.length; i++) {
      var elem: any;

      elem = data.data[i];
      init = data.data[i];

      this.dropdownList.push({ item_id: elem['id'], item_text: elem['department_name']})

      if (this.user.department_id == elem['id']) {
        this.selectedItems = [{ item_id: elem['id'], item_text: elem['department_name'] }];
      }
    }

    if (this.selectedItems.length == 0) {
      this.selectedItems = [{ item_id: init['id'], item_text: init['department_name'] }];
    }

  }

  protected setUserStatus(data) {
    this.user.status = data.checked ? 1 : 0;
  }

  private initializeComponents() {
    this.user = new Users();

    this.user.status = 1;
    this.user.department_id = 1;
    this.roleID = 1;
  }

  private checkInitRoute(route: ActivatedRoute) {

    this.route.url.subscribe(
      params => {
        this.mode = params[0].path == "user_profile" ? "update" : "create";
      }
    )

    this.route.params.subscribe(
      params => {
        if (params['id'] != null) {
          this.usersService.getUser(params['id']).subscribe(
            (data: any) => {
              this.user = data.data;
              this.getDepartments();
              this.user.password = null;
              this.roleUserService.getRoleUsers(this.user.id).subscribe(
                (data: any) => {
                  this.roleID = data.data.role_id;
                }
              )
            }
          );
        }else{
          this.getDepartments();
        }
      }
    )
  }

  private getRoleUser(userID) {
    let roleUser = new RoleUsers();
    roleUser.roleID = this.roleID;
    roleUser.userID = userID;
    
    return roleUser;
  }


  private clearRegistrationForm() {
    this.initializeComponents();
  }

  private exit() {
    this.router.navigateByUrl("/joytogive/users_home");
  }

  
  selectedFile: File

  //Upload PID's
  onFileChanged(event) {
    this.selectedFile = event.target.files[0];
    this.fileName = this.selectedFile.name;
  }
  
  onUpload(){
    this.loadingPID = true
    const uploadData = new FormData();
    uploadData.append('excel', this.selectedFile);
    // uploadData.append('batch_type_id',<any>this.batch.batch_type_id)
    // uploadData.append('call_type_id', <any>this.batch.call_type_id)

    this.usersService.uploadPID(uploadData).subscribe(
      (data) => {
        this.notifierService.showSuccess("Successfully Updated PID");
      },
      (err) => {
        //this.notifierService.showError(JsonManager.getBreakLineSeparatedErrorMessages(err.error.message));
        this.notifierService.showError(err.error.message);
        this.loadingPID = false
      },
      () => {
        this.loadingPID = false
      }
    )
  }


  saveAssignedStaff(){
     let arrList = [];
      //Get ID only
      for(let $i = 0; $i < this.selectedUser.length; $i++){
         const $eUser = this.selectedUser[$i];
         arrList.push({'id':$eUser['item_id']});
      }

    
     //Get Selected Staff
     let newarr = {'selected_users' : []};
     newarr['selected_users'] = arrList;
       console.log('Each:' + JSON.stringify(newarr))
     this.usersService.saveAssignedUsers(newarr).subscribe(
       (data) => { 
          //console.log('Saved Users:' + JSON.stringify(data))
          this.notifierService.showSuccess(data.message);
       },
       (err) => {
         console.log('Error:' + JSON.stringify(err))
       }
     )
  }







}
